import * as Cookies from "tiny-cookie";
import config from "@/config";

export function getLocale(): string {
  const cookieLocale = Cookies.get("locale");
  if (!cookieLocale) {
    return config.locale;
  }
  return cookieLocale;
}
